import { Pipe, PipeTransform, TemplateRef } from '@angular/core';

@Pipe({
  name: 'generateTemplate'
})
export class GenerateTemplatePipe implements PipeTransform {
  transform(value: unknown, context?: any, fallback?: (context: any, template: string) => string): string {
    // TemplateRef<any>
    if (value instanceof TemplateRef) {
      throw new Error('This pipe should only be called if the "isTemplateRef" pipe fails.');
    }

    // TemplateFactory
    if (typeof value === 'function') {
      return value(context) || '';
    }

    // string
    if (typeof value === 'string') {
      return (fallback && fallback(context, value)) || '';
    }

    throw new Error('Template is not a TemplateFactory or a string');
  }
}
